import { ConditionalPartial } from '../../../utils';
import { CreateSopRequestDto } from './create-sop.request.dto';

export class UpdateSopRequestDto extends ConditionalPartial(CreateSopRequestDto) {}
